<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-08-30 11:01:22
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-09-13 20:13:05
-->
<template>
  <div :class="status == 'danger' ? 'red' : status == 'success' ? 'green' : 'gray'">
    <span
      class="circle"
      :class="status == 'danger' ? 'bgRed' : status == 'success' ? 'bgGreen' : 'bgGray'"
    />
    <span class="tag"><slot></slot></span>
  </div>
</template>

<script>
export default {
  name: "LogStatus",
  props: {
    status: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.red {
  color: #e60000;
}
.green {
  color: #00b259;
}
.gray {
  color: gray;
}
.circle {
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 2px solid #ffffff;
  border-radius: 50%;
}
.bgRed {
  background: #e60000;
}
.bgGreen {
  background: #00b259;
}
.bgGray {
  background: gray;
}
</style>
